import { solicitarToken } from "./messaging";

export const probarNotificaciones = async () => {
  const token = await solicitarToken();

  if (token) {
    localStorage.setItem("fcm_token_prueba", token);
    console.log("✅ FCM listo para este dispositivo");
  } else {
    console.log("⚠️ No se obtuvo token FCM");
  }
};